module.exports = __webpack_public_path__ + "static/media/LK_White_Delete.dc791e54.svg";